import { Mail } from "lucide-react";
import { LogoMark } from "./Logo";
import { scrollToSection } from "@/lib/scroll";

const LINKS = [
    { id: "home", label: "Home" },
    { id: "about", label: "About" },
    { id: "practice-areas", label: "Practice Areas" },
    { id: "attorney", label: "Attorney" },
    { id: "testimonials", label: "Testimonials" },
    { id: "contact", label: "Contact" },
];

const Footer = () => (
    <footer data-testid="site-footer" className="bg-[#07111E] text-white">
        <div className="max-w-6xl mx-auto px-6 lg:px-10 py-16 lg:py-20">
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
                <div className="lg:col-span-2">
                    <div className="flex items-center gap-3">
                        <LogoMark size={40} />
                        <span className="leading-tight">
                            <span className="block font-serif-display text-base tracking-wide text-white">
                                DAN ROSENGARTEN
                            </span>
                            <span className="block font-mono-label text-[9px] tracking-[0.32em] text-[#B89047] uppercase">
                                Law Firm
                            </span>
                        </span>
                    </div>
                    <p className="mt-6 text-sm text-white/55 leading-relaxed max-w-sm">
                        A South African legal practice providing professional representation with
                        personal attention. Experienced legal counsel, tailored to your individual
                        legal needs.
                    </p>
                </div>

                <nav aria-label="Footer">
                    <p className="font-mono-label text-[10px] tracking-[0.24em] uppercase text-[#B89047] mb-5">
                        Navigate
                    </p>
                    <ul className="space-y-3">
                        {LINKS.map((l) => (
                            <li key={l.id}>
                                <button
                                    data-testid={`footer-link-${l.id}`}
                                    onClick={() => scrollToSection(l.id)}
                                    className="text-sm text-white/60 hover:text-[#DFCA9B] transition-colors duration-300 cursor-pointer"
                                >
                                    {l.label}
                                </button>
                            </li>
                        ))}
                    </ul>
                </nav>

                <div>
                    <p className="font-mono-label text-[10px] tracking-[0.24em] uppercase text-[#B89047] mb-5">
                        Contact
                    </p>
                    <a
                        data-testid="footer-email-link"
                        href="mailto:danrosengarten01@gmail.com"
                        className="inline-flex items-center gap-2 text-sm text-white/70 hover:text-[#DFCA9B] transition-colors duration-300"
                    >
                        <Mail size={15} aria-hidden="true" />
                        danrosengarten01@gmail.com
                    </a>
                    <p className="mt-6 font-mono-label text-[10px] tracking-[0.24em] uppercase text-[#B89047] mb-3">
                        Disclaimer
                    </p>
                    <p className="text-xs text-white/40 leading-relaxed">
                        The information on this website is provided for general informational
                        purposes only and does not constitute legal advice. Viewing this website or
                        submitting an enquiry does not create an attorney-client relationship; such
                        a relationship arises only once a formal mandate is agreed in writing.
                    </p>
                </div>
            </div>
        </div>
        <div className="border-t border-white/10">
            <div className="max-w-6xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
                <p className="text-xs text-white/40">
                    © {new Date().getFullYear()} Dan Rosengarten Law Firm. All rights reserved.
                </p>
                <p className="font-mono-label text-[10px] tracking-[0.2em] uppercase text-white/30">
                    danrosengartenfirm.com
                </p>
            </div>
        </div>
    </footer>
);

export default Footer;
